// extracted by mini-css-extract-plugin
export default {"menu-item":"HeaderItem_menu-item__GFqC2","icon":"HeaderItem_icon__CqsIh","separator":"HeaderItem_separator__csn-S","active":"HeaderItem_active__8taNC"};